module.exports = __webpack_public_path__ + "c8d48cd63acc34a7fba3e3491ba8f77c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Tutors/images/img_tutor_kv.svg
// module id = 1604
// module chunks = 8